export const warningStyle = {
  background: `linear-gradient(135deg, #fdd835 45.45%, #f4e9b8 45.45%, #f4e9b8 50%, #fdd835 50%, #fdd835 95.45%, #f4e9b8 95.45%, #f4e9b8 100%)`,
  backgroundSize: `11px 11px`,
}

export const errorStyle = {
  background: `linear-gradient(135deg, #ff746a 45.45%, #f79992 45.45%, #f79992 50%, #ff746a 50%, #ff746a 95.45%, #f79992 95.45%, #f79992 100%)`,
  backgroundSize: `11px 11px`,
}

export const lockedStyle = typeColor => ({
  background: `linear-gradient(-45deg,
      rgba(0, 0, 0, 0) 49.9%,
      #fff 49.9%, #fff 60%,
      rgba(0, 0, 0, 0) 60%
  ),
  linear-gradient(-45deg,
  #fff 10%,
  rgba(0, 0, 0, 0) 10%
)`,
  backgroundSize: `7px 7px`,
  backgroundColor: typeColor,
})
